import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'ui-platform-progress-indicator-circle',
  templateUrl: './progress-indicator-circle.component.html',
  styleUrl: './progress-indicator-circle.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class UiPlatformProgressIndicatorCircleComponent {
  @Input() progress = 0;

  size = 16 * 6; // has to be in pixels, no rems here...
  stroke = 16 / 2; // has to be in pixel

  get dashOffset() {
    const multiplier = (360 - 120) / 100; // 120 is a magic constant based on overall size

    if (this.progress === 0) {
      return 360;
    }
    if (this.progress === 100) {
      return 0;
    }
    return Math.floor(360 - this.progress * multiplier);
  }

  get leadDynamicStyle() {
    return { 'stroke-dashoffset': this.dashOffset };
  }

  get circlePosition() {
    return this.size / 2;
  }

  get circleRadius() {
    return this.size / 2 - this.stroke;
  }
}
